import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useNotification } from '../contexts/NotificationContext'
import { useUser } from '../contexts/userContext'
import { routes } from '../routes'
import { preventUserCreateGame } from '../util/game'

export const useGameEditorNavigation = () => {
  const navigate = useNavigate()
  const { notifyError } = useNotification()
  const { t } = useTranslation()
  const { user } = useUser()

  const goToCreateGame = useCallback(async () => {
    if (preventUserCreateGame(user)) {
      notifyError({
        title: t('dashboard.notifications.trial_expired.title', 'Creating the game failed'),
        content: t(
          'dashboard.notifications.trial_expired.content',
          'You need a valid licence to create a game. Update your licence or contact us for support',
        ),
      })
    } else {
      navigate(routes.gameEditor)
    }
  }, [user, notifyError, t, navigate])

  const createGameWithAi = useCallback(() => {
    navigate(routes.engine)
  }, [navigate])

  return { goToCreateGame, createGameWithAi }
}
